import { useEffect } from 'react';
import { ServiceRepository } from '../repositories/service.repository.ts';
import { useServiceStore } from '../stores/service.store.ts';
import { userStore } from '../stores/user.store.ts';

/**
 * 카테고리·서브카테고리·배너 카탈로그가 스토어에 있도록 보장한다.
 *
 * 이 카탈로그는 홈과 로그인에서만 받아왔다. 그래서 홈을 거치지 않고 바로 들어오는
 * 경로 — 새로고침, 외부 링크, 쿠폰 상세의 '지금 사용하러 가기' — 에서는
 * 카테고리 화면의 상단 배너와 서브카테고리 칩이 통째로 비어 있었다.
 *
 * fetchDashboard 는 이미 받아둔 경우 그냥 돌아오므로(hasDashboard + authKey 비교)
 * 필요한 화면마다 불러도 중복 요청이 되지 않는다.
 */
export function useEnsureDashboard(): void {
  const hasDashboard = useServiceStore((s) => s.hasDashboard);

  useEffect(() => {
    if (hasDashboard) return;

    const user = userStore.getState().user;
    ServiceRepository.fetchDashboard({ authKey: user?.uuid ? `user:${user.uuid}` : 'guest' });
  }, [hasDashboard]);
}
